var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_page"},[(_vm.showMessage)?_c('div',{staticClass:"message"},[_c('h1',[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }